import { render } from "./admin-logout.svg?vue&type=template&id=2101a606"
const script = {}
script.render = render

export default script